import { render } from "./DeliveryMail.vue?vue&type=template&id=061153a5"
import script from "./DeliveryMail.vue?vue&type=script&lang=js"
export * from "./DeliveryMail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__